import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';

import NewModal from '../../components/UI/Modal/index';
import Loader from '../../components/Loader';
import PaymentReceiptPreviewModal from './PaymentAccount/PaymentReceiptPreviewModal';

const formatDateTime = (value) => {
    if (!value) return '—';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';

    return date.toLocaleString('ru-RU');
};

const DetailsPaymentAccount = ({
    item,
    show,
    setShowDetails,
}) => {
    const [receiptIndex, setReceiptIndex] = useState(null);

    const handleClose = () => {
        setReceiptIndex(null);
        setShowDetails(false);
    };

    if (!show) return null;
    if (!item) return <Loader />;

    const receipts = Array.isArray(item.itemPictures) ? item.itemPictures : [];

    return (
        <>
            <NewModal
                show={show}
                handleClose={handleClose}
                disabledFunctional
                modalTitle={`Подробное описание к счету: ${item._id}`}
                size="lg"
            >
                <Row>
                    <Col md="6">
                        <label className="key">Сумма</label>
                        <p className="value">{item.price}</p>
                    </Col>
                    <Col md="6">
                        <label className="key">Тип</label>
                        <p className="value">
                            {item.type === 'office' ? 'Расход офиса' : 'Оплата клиента'}
                        </p>
                    </Col>
                </Row>

                <Row>
                    <Col md="12">
                        <label className="key">Дата и время создания</label>
                        <p className="value">{formatDateTime(item.createdAt || item.date)}</p>
                    </Col>
                    <Col md="12">
                        <label className="key">Дата и время последнего обновления</label>
                        <p className="value">{formatDateTime(item.updatedAt)}</p>
                    </Col>
                </Row>

                <Row>
                    <Col md="12">
                        <label className="key">Подробное описание</label>
                        <p className="value">{item.description || 'Без описания'}</p>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <label className="key">Чеки / файлы</label>

                        {!receipts.length ? (
                            <div className="paymentReceiptListAdmin__empty">
                                К этой операции файлы не прикреплены.
                            </div>
                        ) : (
                            <div className="paymentReceiptListAdmin">
                                {receipts.map((receipt, index) => (
                                    <button
                                        key={receipt?._id || receipt?.receiptId || index}
                                        type="button"
                                        className="paymentReceiptListAdmin__item"
                                        onClick={() => setReceiptIndex(index)}
                                    >
                                        <span>Чек {index + 1}</span>
                                        <small>
                                            {receipt?.originalName || 'Файл чека'}
                                            {receipt?.mimeType ? ` · ${receipt.mimeType}` : ''}
                                        </small>
                                    </button>
                                ))}
                            </div>
                        )}
                    </Col>
                </Row>
            </NewModal>

            <PaymentReceiptPreviewModal
                show={receiptIndex !== null}
                paymentAccountId={String(item._id || '')}
                receipts={receipts}
                initialIndex={receiptIndex || 0}
                onClose={() => setReceiptIndex(null)}
            />
        </>
    );
};

export default DetailsPaymentAccount;
